module.exports = __webpack_public_path__ + "img/growth.44103cf1.svg";